import { render, staticRenderFns } from "./AssistantBaseView.vue?vue&type=template&id=5d98c133&"
import script from "./AssistantBaseView.vue?vue&type=script&lang=js&"
export * from "./AssistantBaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports